import SparkMD5 from 'spark-md5';

// uuid
export function uuid() {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function(c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
}

// 拷贝
export function deepCopy(target) {
  if (typeof target === 'object') {
    const result = Array.isArray(target) ? [] : {};
    for (const key in target) {
      if (typeof target[key] === 'object') {
        result[key] = deepCopy(target[key]);
      } else {
        result[key] = target[key];
      }
    }
    return result;
  }
  return target;
}

// 获取style属性
export function getStyle(ele, prop) {
  return getComputedStyle(ele, false)[prop];
}

// 数组对象去重
export function arrUnique(arr, props) {
  const result = {};
  const finalResult = [];
  for (let i = 0; i < arr.length; i++) {
    // 利用对象的键名无法重复的特点，cpmch_id是唯一区别的属性值
    result[arr[i][props]]
      ? ''
      : (result[arr[i][props]] = true && finalResult.push(arr[i]));
  }
  return finalResult;
}

const tabMap = {
  createHandout: 'createHandout',
  createCourse: 'createCourse',
  topTabThird: 'topTabThird'
};

// 获取当前url参数-新建tab时保留
export function getCurrentRouteInfo(routec) {
  const tabId = tabMap[routec.name] ? tabMap[routec.name] : 'home';
  return {
    tabId: tabId
  };
}

// 处理级联选择改变导致浏览器卡死 CPU占用超过100% 的bug
export function handleCascaderChange() {
  const $el = document.querySelectorAll('.el-cascader-panel .el-cascader-node[aria-owns]');
  Array.from($el).map(item => item.removeAttribute('aria-owns'));
}

// 设置页码文字
export function setPageText() {
  try {
    // 修改页面文案
    document.getElementsByClassName(
      'el-pagination__jump'
    )[0].childNodes[0].nodeValue = '跳至';
  } catch (err) {
    console.log(err);
  }
}

// ios判断
export function OSnow() {
  var agent = navigator.userAgent.toLowerCase();
  var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
  if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
    console.log('这是windows32位系统');
  }
  if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
    console.log('这是windows64位系统');
  }
  if (isMac) {
    console.log('这是mac系统');
    return true;
  }
}
export const isXPad = () => {
  return /xpad|xPad|TALIH/i.test(navigator.userAgent);
};
/**
 * 判断是否是pc端
 * @returns {boolean} flag
 */
export const IsPC = () => {
  const userAgentInfo = navigator.userAgent;
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false; break;
    }
  }
  if (!flag && isXPad()) {
    return true;
  }
  return flag;
};

// 设置tab的title/favicon
export function setTitle(name, icon) {
  if (name) {
    document.title = name;
  }
  if (icon) {
    const $favicon = document.querySelector('link[rel="icon"]');
    if ($favicon !== null) {
      $favicon.href = icon;
    }
  }
}

const GFMAP = {
  Img: 21,
  Ppt: 22,
  Pdf: 23,
  Mp3: 24,
  Mp4: 25,
  Word: 26
};
const GFImg = /(?=image)/g;
const GFPpt = /(?=ppt)/g;
const GFPdf = /(?=pdf)/g;
const GFMp3 = /(?=audio)/g;
const GFMp4 = /(?=video)/g;
const GFWord = /(?=doc)/g;
// 识别文件类型
export function getFileType(type, name) {
  if (GFImg.test(type) || GFImg.test(name)) return GFMAP.Img;
  if (GFPpt.test(type) || GFPpt.test(name)) return GFMAP.Ppt;
  if (GFPdf.test(type) || GFPdf.test(name)) return GFMAP.Pdf;
  if (GFMp3.test(type) || GFMp3.test(name)) return GFMAP.Mp3;
  if (GFMp4.test(type) || GFMp4.test(name)) return GFMAP.Mp4;
  if (GFWord.test(type) || GFWord.test(name)) return GFMAP.Word;
}

export const copyToClipboard = (value) => {
  const transfer = document.createElement('textarea');
  document.body.appendChild(transfer);
  transfer.value = value; // 这里表示想要复制的内容
  transfer.focus();
  transfer.select();
  if (document.execCommand('copy')) {
    document.execCommand('copy');
  }
  transfer.blur();
  document.body.removeChild(transfer);
};

export const selectAllOnFocus = (dom) => {
  let range;
  if (document.selection) {
    range = document.body.createTextRange();
    range.moveToElementText(dom);
    range.select();
  } else if (window.getSelection) {
    range = document.createRange();
    range.selectNodeContents(dom);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
  }
};

export const getFormatFileSize = (value) => {
  if (value > 0) {
    if (value < 1 * 1024 * 1024) {
      // 如果小于1M,显示成k
      return parseInt((value / 1024) * 100) / 100 + 'K';
    }
    if (value < 1 * 1024 * 1024 * 1024) {
      // 如果小于1G,显示成M
      return parseInt((value / 1024 / 1024) * 100) / 100 + 'M';
    }

    return parseInt((value / 1024 / 1024 / 1024) * 100) / 100 + 'G';
  } else {
    return '--';
  }
};

export const computeMD5 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    const blobSlice =
      File.prototype.slice ||
      File.prototype.mozSlice ||
      File.prototype.webkitSlice;
    // 2MB
    const chunkSize = 2097152;
    const spark = new SparkMD5.ArrayBuffer();
    // 区分分片计算还是直接计算，如果小于2M，直接计算MD5
    if (file.size < chunkSize) {
      fileReader.onload = (e) => {
        const fileMd5 = SparkMD5.ArrayBuffer.hash(e.target.result);
        resolve(fileMd5);
      };
      fileReader.onerror = (e) => {
        reject(e);
      // reject(new Error('生成MD5失败！'))
      };
      fileReader.readAsArrayBuffer(file);
    } else {
      const chunks = Math.ceil(file.size / chunkSize);
      let currentChunk = 0;
      const time = new Date().getTime();
      // console.log('计算MD5...')

      fileReader.onload = (e) => {
        spark.append(e.target.result); // Append array buffer
        currentChunk++;

        if (currentChunk < chunks) {
          console.log(
            `第${currentChunk}分片解析完成, 开始第${
              currentChunk + 1
            } / ${chunks}分片解析`
          );
          loadNext();
        } else {
          console.log('finished loading');
          const md5 = spark.end();
          console.log(
            `MD5计算完成：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${
              file.size
            } 用时：${new Date().getTime() - time} ms`
          );
          spark.destroy(); // 释放缓存
          resolve(md5);
        }
      };
      fileReader.onerror = (e) => {
        reject(e);
      // reject(new Error('生成MD5失败！'))
      };

      const loadNext = () => {
        const start = currentChunk * chunkSize;
        const end =
        start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
      };

      loadNext();
    }
  });
};

// 获取 sessionStorage 中的在线客服信息
// templateId: 模板ID  qtype：常见问题模板ID  welcomeTemplateId：欢迎语模板
export function getSessionStorageData() {
  const ysfConfig = JSON.parse(sessionStorage.getItem('ysfConfig') || '{}');
  const { templateId = '', qtype = '', welcomTemplateId = '' } = ysfConfig;
  return { templateId, qtype, welcomTemplateId };
}

export const openClient = (protocoUrl, isIos, failCb) => {
  console.log('打开客户端', protocoUrl, isIos);
  callAppPC({
    // 客户端自定义URL，这个url地址换成需要唤醒的客户端的URL Protoco
    url: protocoUrl,
    callback: () => failCb()
  });
};

export const callAppPC = ({ url, callback }) => {
  const t = setTimeout(callback, 1000);
  const inp = document.createElement('input');
  inp.style.position = 'absolute';
  inp.style.clip = 'rect(0, 0, 0, 0)';
  function blur() {
    window.clearTimeout(t);
  }
  inp.addEventListener('blur', blur); // 监听blur事件
  document.body.appendChild(inp);
  inp.focus(); // 获取焦点
  setTimeout(function() {
    // 删除无用的标签
    inp.removeEventListener('blur', blur);
    document.body.removeChild(inp);
  }, 1000);
  // 有客户端 如果有本地exe应用，就会弹框，input失去焦点，然后执行blur()事件 清空t定时器 - 删除无用的标签定时器
  // 无客户端 不会弹框，input也不会失去焦点 触发t定时器- 执行callback - 删除无用的标签定时器
  location.href = url;
};

/**
 * 设置sesstion storage
 * @param {*} key
 * @param {*} value
 */
export const setSessionStorage = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

/**
 * 获取sesstion storage
 * @param {*} key
 * @returns
 */
export const getSessionStorage = (key) => {
  return sessionStorage.getItem(key);
};
/**
 * 给url添加参数
 * @param {*} key
 * @param {*} value
 */
export const appendParamsToUrl = (url, key, value) => {
  const reg = new RegExp(`(\\?|&)${key}=([^&]*)(&|$)`);
  const result = url.match(reg);
  if (result) {
    return url.replace(reg, `$1${key}=${value}$3`);
  } else {
    const separator = url.indexOf('?') !== -1 ? '&' : '?';
    return `${url}${separator}${key}=${value}`;
  }
};

// 获取文件类型
export const getFileFormate = (file) => {
  const { name } = file;
  if (!name) return '';
  const index = name.lastIndexOf('.');
  return name.slice(index + 1).toLowerCase();
};
// el-input 根据输入框光标位置获取输入框做粘贴后的文本
export const getPasteHandleTxt = (event, elInput, total = 150) => {
  const value = event.clipboardData.getData('Text');
  // 获取el-input的值
  const txt = elInput.value;

  // 插入前做长度校验
  if (total === 150 && txt.length + value.length > total) {
    return;
  }
  // 获取选区开始位置
  const startPos = elInput.selectionStart;
  // 获取选区结束位置
  const endPos = elInput.selectionEnd;
  if (startPos === undefined || endPos === undefined) return;

  // 将光标移至文本末尾
  elInput.focus();
  elInput.selectionStart = startPos + value.length;
  elInput.selectionEnd = startPos + value.length;
  return txt.substring(0, startPos) + value + txt.substring(endPos);
};
export const checkIsChrome = () => {
  const userAgent = navigator.userAgent;
  if (userAgent.indexOf('Chrome') > -1) {
    return true;
  }
  return false;
};
export const getChromeVersion = () => {
  const arr = navigator.userAgent.split(' ');
  let chromeVersion = '';
  for (var i = 0; i < arr.length; i++) {
    if (/chrome/i.test(arr[i])) {
      chromeVersion = arr[i];
    }
  }
  if (chromeVersion) {
    return Number(chromeVersion.split('/')[1].split('.')[0]);
  } else {
    return false;
  }
};
/**
 * 判断浏览器类型用于是否提示下载chrome浏览器
 * @returns boolean
 */
export const isShowBrowserAlert = () => {
  const isChrome = checkIsChrome();
  const chromeVersion = getChromeVersion();
  if (!isChrome || chromeVersion < 59) {
    return true;
  }
  return false;
};
/**
 * 通过浏览器宽度获取云盘列表动态列宽
 * @param clientWidth 浏览器宽度
 */
export const getDynamicColumnWidth = (clientWidth) => {
  if (clientWidth < 1280) {
    return '100';
  } else if (clientWidth < 1680) {
    return '140';
  } else if (clientWidth < 1680) {
    return '160';
  } else {
    return '200';
  }
};
export const getRequestParams = () => {
  const href = window.location.href;
  const params = {};
  if (href.indexOf('?') !== -1) {
    const index = href.indexOf('?');
    const query = href.slice(index + 1);
    const strs = query.split('&');
    for (var i = 0; i < strs.length; i++) {
      params[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
    }
  }
  return params;
};

export const replaceSVGWithImage = (html) => {
  // 创建一个新的div元素
  const container = document.createElement("div");
  // 将HTML内容插入到新创建的div中
  container.innerHTML = html;
  // 在当前文档中插入新创建的div
  document.body.appendChild(container);

  // 使用新创建的div来获取SVG元素
  const svgElements = container.querySelectorAll("svg");
  console.log(svgElements);

  svgElements.forEach(function (svgElement) {
      // 创建一个新的img元素
      const imgElement = document.createElement("img");
      // 设置img元素的src属性为SVG内容的base64编码
      imgElement.src =
          "data:image/svg+xml;base64," +
          btoa(
              unescape(
                  encodeURIComponent(
                      new XMLSerializer().serializeToString(svgElement)
                  )
              )
          );
      let widthFromAttribute =  svgElement.getAttribute("wight");
      let heightFromAttribute = svgElement.getAttribute("height");

      // 有时width和height可能是数值类型没有单位，有时候会有单位比如'px'，需要做相应处理
      if (typeof widthFromAttribute === 'string') {
          widthFromAttribute = parseFloat(widthFromAttribute.replace(/[^-\d\.]/g, '')); // 去除单位
      }

      if (typeof heightFromAttribute === 'string') {
          heightFromAttribute = parseFloat(heightFromAttribute.replace(/[^-\d\.]/g, '')); // 去除单位
      }

      // 通过CSS样式获取计算后的实际宽高（考虑了样式表的影响）
      var computedWidth = window.getComputedStyle(svgElement).width;
      var computedHeight = window.getComputedStyle(svgElement).height;
      console.log("eeeeeeeeeeeee", computedWidth);

      imgElement.width = Number.parseInt(computedWidth);
      imgElement.height = Number.parseInt(computedHeight);
      // 将img元素插入到SVG元素之前
      svgElement.parentNode.insertBefore(imgElement, svgElement);
      // 删除原始的SVG元素
      svgElement.parentNode.removeChild(svgElement);
  });

  // 获取替换后的HTML内容
  const modifiedHtmlContent = container.innerHTML;

  // 清理新创建的div
  document.body.removeChild(container);

  return modifiedHtmlContent;
}

// canvas绘制图片
const canvasDrawImg = (img, scale = 0.8) => {
  // 创建 OffscreenCanvas
  const canvas = document.createElement('canvas')
  const imageWidth = img.width
  const imageHeight = img.height
  const scaleWidth = imageWidth * scale
  const scaleHeight = imageHeight * scale
  canvas.width = scaleWidth
  canvas.height = scaleHeight
  const ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, scaleWidth, scaleHeight)
  return canvas
}

// 本地文件转base64
export const getFileBase64 = (file, { scale = 0.8, quality = 0.6 } = {}) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      const img = new Image()
      img.src = e.target.result
      img.onload = () => {
        const canvas = canvasDrawImg(img, scale)
        const dataURL = canvas.toDataURL('image/jpeg', quality)
        resolve(dataURL)
      }
      img.onerror = () => {
        reject('无效图片')
      }
    }
    reader.readAsDataURL(file)
  })
}

// base64转本地文件
export const base64ToFile = (base64, filename, mimeType) => {
  const sliceSize = 512;
  const byteCharacters = atob(base64.split(',')[1]);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: mimeType });
  return new File([blob], filename, { type: mimeType });
}

export const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}